import { EVENT_DATA_FIELD_KEYS } from './eventDataFieldKeys';
import { BLOCKED_EVENT_DATA_FIELD_KEYS } from './blockedEventDataFieldKeys';
import { METRIC_DATA_FIELD_KEYS } from './metricDataFieldKeys';
import { CALCULATION_DATA_FIELD_KEYS } from './calculationDataFieldKeys';

export * from './customEventDataFieldKey';
export * from './customCalculationDataFieldKey';
export * from './cohortsDataFieldKeys';

export { EVENT_DATA_FIELD_KEYS, BLOCKED_EVENT_DATA_FIELD_KEYS, METRIC_DATA_FIELD_KEYS, CALCULATION_DATA_FIELD_KEYS };

export const DATA_FIELD_KEYS = {
  ...EVENT_DATA_FIELD_KEYS,
  ...BLOCKED_EVENT_DATA_FIELD_KEYS,
  ...METRIC_DATA_FIELD_KEYS,
  ...CALCULATION_DATA_FIELD_KEYS,
} as const;
